<template>
<div :class="$style.wrapper">
  <div :class="$style.content3">
    <div :class="$style.content3I">
      <img :class="$style.content3II" :src="yywI25" alt="" />
      <div :class="$style.content3IT">
        <div :class="$style.content3ITT">守护未成年</div>
        <div :class="$style.content3ITD">共同维护成长净土</div>
      </div>
    </div>
    <div :class="$style.content3Dir"></div>
    <div :class="$style.content3I">
      <img :class="$style.content3II" :src="yywI26" alt="" />
      <div :class="$style.content3IT">
        <div :class="$style.content3ITT">保障交易安全</div>
        <div :class="$style.content3ITD">终生售后，100%包赔付</div>
      </div>
    </div>
    <div :class="$style.content3Dir"></div>
    <div :class="$style.content3I">
      <img :class="$style.content3II" :src="yywI27" alt="" />
      <div :class="$style.content3IT">
        <div :class="$style.content3ITT">海量游戏类型</div>
        <div :class="$style.content3ITD">你想要的，都能找到</div>
      </div>
    </div>
    <div :class="$style.content3Dir"></div>
    <div :class="$style.content3I">
      <img :class="$style.content3II" :src="yywI28" alt="" />
      <div :class="$style.content3IT">
        <div :class="$style.content3ITT">一对一服务</div>
        <div :class="$style.content3ITD">任何问题方便快速解答</div>
      </div>
    </div>
  </div>
</div>

</template>

<script setup>
import yywI25 from "@assets/image/yywI25.png";
import yywI26 from "@assets/image/yywI26.png";
import yywI27 from "@assets/image/yywI27.png";
import yywI28 from "@assets/image/yywI28.png";
</script>

<style module>
.wrapper {
 padding: 20px 240px 0;
}
.content3 {
  display: flex;
  align-items: center;
  padding-left: 30px;
  width: 100%;
  height: 80px;
  border-radius: 10px;
  background-color: #ffffff;
  margin-top: 69px;
  margin-bottom: 20px;
  /* margin-left: 240px; */
}
.content3I {
  width: 269px;
  height: 40px;
  display: flex;
  align-items: center;
}
.content3Dir {
  width: 1px;
  height: 40px;
  background-color: #cccccc;
  margin-right: 110px;
}
.content3II {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.content3ITT {
  font-family: "PingFangSC-semibold";
  color: #333333;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
  line-height: 20px;
}
.content3ITD {
  font-family: "PingFangSC-regular";
  color: #999999;
  font-weight: 400;
  font-size: 13px;
}
</style>